import {
  UserStoreStatisticsState,
  REQUEST_USERSTATISTICS_FOR_STORE,
  REQUEST_USERSTATISTICS_FOR_STORE_DONE
} from "./types";

const initialState: UserStoreStatisticsState = {
  isLoading: true,
  userStoreStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_USERSTATISTICS_FOR_STORE:
      return {
        isLoading: true,
        userStoreStatistics: action.payload
      };
    case REQUEST_USERSTATISTICS_FOR_STORE_DONE:
      return {
        isLoading: false,
        userStoreStatistics: action.payload
      };
    default:
      return state;
  }
}
